export const accessMatrix = {
  "Super Admin": {
    permissions: {
      "Data Admin": ["lihat", "tambah", "edit", "hapus"],
      "Data Karyawan": ["lihat", "tambah", "edit", "hapus"],
      "Data Mitra": ["lihat", "tambah", "edit", "hapus"],
      "Data Komisi": ["lihat", "tambah", "edit", "hapus"],
      "Transaksi Singkong": ["lihat", "tambah", "edit", "hapus"],
      "Verifikasi Singkong": ["lihat", "tambah", "edit", "hapus"],
      "Manajemen Akses": ["lihat", "tambah", "edit", "hapus"],
      "User Setup": ["lihat", "tambah", "edit", "hapus"],
    },
  },
  Admin: {
    permissions: {
      "Verifikasi Singkong": ["lihat", "tambah", "edit", "hapus"],
      "Transaksi Singkong": ["lihat", "tambah", "edit", "hapus"],
    },
  },
  "Admin HR": {
    permissions: {
      "Data Admin": ["lihat", "tambah", "edit", "hapus"],
      "Data Karyawan": ["lihat", "tambah", "edit", "hapus"],
      "Data Mitra": ["lihat", "tambah", "edit", "hapus"],
      "Manajemen Akses": ["lihat", "tambah", "edit", "hapus"],
    },
  },
  "Admin Finance": {
    permissions: {
      "Verifikasi Singkong": ["lihat", "tambah", "edit", "hapus"],
      "Transaksi Singkong": ["lihat", "tambah", "edit", "hapus"],
    },
  },
  "Field Agent": {
    permissions: {
      "Data Mitra": ["lihat", "tambah", "edit", "hapus"],
      "Verifikasi Singkong": ["lihat", "tambah", "edit", "hapus"],
    },
  },
  "R&D": {
    permissions: {
      Profil: ["lihat"],
    },
  },
  Marketing: {
    permissions: {
      "Verifikasi Singkong": ["lihat", "tambah", "edit", "hapus"],
      "Transaksi Singkong": ["lihat"],
    },
  },
  Mitra: {
    permissions: {
      "Verifikasi Singkong": ["lihat"],
      "Transaksi Singkong": ["lihat"],
    },
  },
};
